export default __webpack_public_path__ + "static/media/Host.2bf29059.jpeg";